export default __webpack_public_path__ + "static/media/a023-short3.9c2d933e.jpg";